import { FunctionComponent } from 'react';
import styles from './PriceCard.module.scss';
import FancyLabel from '../../texts/FancyLabel/FancyLabel';
import MainButton from '../../buttons/MainButton/MainButton';
import classNames from 'classnames';

interface PriceCardProps {
  title: string | React.ReactElement;
  labelText?: string;
  buttonText?: string;
  topBannerText?: string;
  className?: string;
  onClick?: (e?) => void;
}

const PriceCard: FunctionComponent<PriceCardProps> = ({
  title,
  labelText,
  buttonText,
  topBannerText,
  className,
  onClick,
}) => {
  return (
    <div className={classNames(styles['card'], className)} onClick={onClick}>
      {topBannerText && <div className={styles['card__top-banner']}>{topBannerText}</div>}

      <div className={styles['card__content']}>
        {labelText && (
          <div className={styles['card__label']}>
            <FancyLabel text={labelText} />
          </div>
        )}

        <div className={styles['card__title']}>{title}</div>

        {buttonText && (
          <MainButton className={styles['card__button']} visualType="white" sizeType="medium">
            {buttonText}
          </MainButton>
        )}
      </div>
    </div>
  );
};

export default PriceCard;
